import { formatTimeAs, uses24Hour } from './time';
/** Dates are plain YYYY-MM-DD strings in the coach's local time; times are HH:MM. */

export function today(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

const asDate = (s: string) => new Date(`${s}T00:00:00`);

const fmt = (opts: Intl.DateTimeFormatOptions) => new Intl.DateTimeFormat('en-AU', opts);
const longDay = fmt({ weekday: 'long', day: 'numeric', month: 'long' });
const shortDay = fmt({ weekday: 'short', day: 'numeric', month: 'short' });
const dayNum = fmt({ day: 'numeric' });
const weekday = fmt({ weekday: 'short' });
const monthYear = fmt({ month: 'long', year: 'numeric' });
const dayMonth = fmt({ day: 'numeric', month: 'short' });

export const formatLongDay = (s: string) => longDay.format(asDate(s)).replace(',', '');
export const formatShortDay = (s: string) => shortDay.format(asDate(s)).replace(',', '');
export const formatDayNum = (s: string) => dayNum.format(asDate(s));
export const formatWeekday = (s: string) => weekday.format(asDate(s));
export const formatMonthYear = (s: string) => monthYear.format(asDate(s));
export const formatDayMonth = (s: string) => dayMonth.format(asDate(s));

/** "16:30" → "4:30 pm", or "16:30" when this device is set to 24-hour times. */
export function formatTime(t: string) {
  return formatTimeAs(t, uses24Hour());
}

/** "1 hr 30 min", "45 min" */
export function formatMinutes(mins: number) {
  if (mins < 60) return `${mins} min`;
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return m ? `${h} hr ${m} min` : `${h} hr`;
}

export function weekLabel(start: string, end: string) {
  const a = asDate(start);
  const b = asDate(end);
  if (a.getMonth() === b.getMonth()) return `${dayNum.format(a)} – ${dayNum.format(b)} ${monthYear.format(b)}`;
  return `${dayMonth.format(a)} – ${dayMonth.format(b)} ${b.getFullYear()}`;
}
